import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-24 bg-gradient-to-br from-[#F0FFF4] to-white" data-id="element-295">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-296">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-297">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="relative rounded-3xl overflow-hidden shadow-2xl aspect-square lg:aspect-auto lg:h-[600px]" data-id="element-298">
            <img src="https://images.unsplash.com/photo-1515377905703-c4788e51af15?auto=format&fit=crop&q=80&w=1000" alt="Woman feeling heavy and tired" className="w-full h-full object-cover" data-id="element-299" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent flex items-end p-8" data-id="element-300">
              <p className="text-white text-lg font-medium italic" data-id="element-301">
                "I felt like I was carrying around 5 pounds of extra water
                weight every single day."
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-302">
            <span className="text-[#10B981] font-bold uppercase tracking-wider text-sm" data-id="element-303">
              The Problem
            </span>
            <h2 className="text-4xl md:text-5xl font-bold text-[#1B5E20] mb-6 mt-2" data-id="element-304">
              When Flow Stops, <br data-id="element-305" />
              <span className="text-[#10B981]" data-id="element-306">Problems Start</span>
            </h2>

            <p className="text-lg text-[#374151] mb-6 leading-relaxed" data-id="element-307">
              Your lymphatic system is responsible for clearing waste and excess
              fluid. When it slows down due to stress, diet, or lifestyle, you
              experience puffiness, bloating, swelling, fatigue, heavy legs, and
              dull skin.
            </p>

            <p className="text-xl text-[#1B5E20] mb-8 font-bold" data-id="element-308">
              LymphoriaX helps restore healthy flow so you can look and feel
              your best.
            </p>

            <div className="space-y-4 bg-white p-8 rounded-2xl shadow-lg border-2 border-[#10B981]/20" data-id="element-309">
              {['Reduces visible puffiness in face and body', 'Restores healthy circulation and lymph flow', 'Releases trapped fluid and reduces bloating', 'Boosts daily energy and mental clarity'].map((item, i) => <div key={i} className="flex items-center space-x-3" data-id="element-310">
                  <div className="bg-[#10B981] p-1 rounded-full" data-id="element-311">
                    <XCircle className="w-4 h-4 text-white rotate-45" data-id="element-312" />
                  </div>
                  <span className="text-[#1B5E20] font-medium" data-id="element-313">{item}</span>
                </div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}